export default __webpack_public_path__ + "static/media/two.7112f711.jpg";